import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { setCrewSignature } from '../store/signatures.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getCrewSignature() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcr._attachments) {
      if (pcr._attachments.StandardSignatures_Section3_Crew !== undefined) {
        const crewSignature = pcr._attachments.StandardSignatures_Section3_Crew
        const signature = document.createElement('img')
        signature.src = 'data:' + crewSignature.fileExtension + ';base64,' + crewSignature.data
        yield put(setCrewSignature(signature.src))
      } else {
        yield put(setCrewSignature(null))
      }
    } else {
      yield put(setCrewSignature(null))
    }
  } catch (e) {
    yield put(throwPcrException(`getCrewSignature() error: ${e}`))
  }
}

export function* getCrewSignatureSaga() {
  yield takeLatest([SignaturesConstants.GET_SIGNATURES], performWithMutexHOG, getCrewSignature)
}
